export default __webpack_public_path__ + "static/media/snake-head.7e3215de.png";